import { defaultHttpClient } from '../../httpClient';
import type { RecommendedGoodsResponse } from '../types';

// 검색 보조 화면 - 최근 본 검색 상품 추천 캐로셀 (EXP1802)
export const getRecommendedGoods = async () => {
  return defaultHttpClient
    .request<RecommendedGoodsResponse>({
      method: 'GET',
      url: '/api/v2/search/recommended-goods/',
    })
    .then(result => result.data);
};
